import React, { useRef, useEffect } from 'react'
import { picProcess } from '../../utils/image'
import useIntersectionObserver from '../../common/hooks/useIntersectionObserver'

export default (props) => {
  const { src, className, style, onObserver, observerParams, picConfig, ...otherProps } = props
  const $img = useRef()
  const entry = useIntersectionObserver($img, observerParams || {})
  useEffect(() => {
    onObserver?.(entry)
    if (!!entry?.isIntersecting) {
      const imgSrc = $img.current.getAttribute('data-src')
      $img.current.src = picProcess(imgSrc, picConfig)
    }
  }, [entry])
  useEffect(() => {
    // 懒加载在复用的时候，会出现src改变但是图片未改变的情况，因为仅src改变intersection识别不了，所有补救一下
    if ($img.current.src && $img.current.src != src) {
      $img.current.src = src
    }
  }, [src])

  return <img className={className} style={style} data-src={src} ref={$img} {...otherProps} />
}
